// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { carouselStyles } from "@rpsc/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.carouselCellGridItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        .swiper-initialized {
            width: 100%;
            margin: 0;
            padding: 0 1px;
        }
        .xng-arrow-navigation-container {
            padding: 0 2px;
        }
    `,
};

carouselStyles.attributeWrapper = {
    width: 12,
    css: css`
        padding: 16px;
        width: 100%;
        > div:nth-child(even) {
            background-color: ${color("common.ui2")};
        }
    `,
};

carouselStyles.mainContainer = {
    offsetCss: css`
        justify-content: flex-end;
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        display: flex;
        width: 100%;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 14,
    weight: fontConfig.weight.bold,
    color: "common.black",
    css: css`
        letter-spacing: 0;
        line-height: 17px;
    `,
};
carouselStyles.attributeValue = {
    as: "p",
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        padding: 6px 12px;
        p,
        span {
            text-wrap: wrap;
            white-space: unset;
        }
        ${xScreen("lte", "md")} {
            padding: 12px;
        }
    `,
};
carouselStyles.attributeLabelGridItem = {
    width: [12, 12, 12, 3, 3],
    css: css`
        padding: 8px 12px;
        align-items: center;
        position: relative;
        ${xScreen("lte", "md")} {
            padding: 8px 12px;
            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                width: calc(100% - 24px);
                border-bottom: 1px solid ${color("common.border")};
            }
        }
    `,
};
carouselStyles.attributeCarouselGridItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        padding: 0;
        &&& {
            .swiper-scrollbar-horizontal {
                margin-top: 0;
            }
        }
    `,
};
